import React, { useEffect, useState } from "react";
import StoreAPI from "../../../api/StoreApi";
import { showError, showSuccess } from "../../../utils/toastUtils";
import { useLoader } from "../../../utils/LoaderUtils";
import { handleApiValidationError } from "../../../utils/apiErrorHandler";

function SocialMediaSettings() {
  const { showLoader, hideLoader } = useLoader();

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const INITIAL_FORM_DATA = {
    facebook: "",
    instagram: "",
    linkedin: "",
    xurl: "",
    youtube: "",
    whatsapp: "",
    googleClientId: "",
    googleAnalyticsId: "",
    metaPixelId: "",
    googleTagManagerId: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    fetchSocialMediaDetails();
  }, []);

  const fetchSocialMediaDetails = async () => {
    try {
      const res = await StoreAPI.socialMediaDetails();

      if (res.code === 200) {
        const result = res.data;

        setFormData({
          facebook: result.facebook || "",
          xurl: result.xurl || "",
          youtube: result.youtube || "",
          linkedin: result.linkedin || "",
          instagram: result.instagram || "",
          whatsapp: result.whatsapp || "",
          googleClientId: result.googleClientId || "",
          googleAnalyticsId: result.googleAnalyticsId || "",
          metaPixelId: result.metaPixelId || "",
          googleTagManagerId: result.googleTagManagerId || "",
        });
      }
    } catch (err) {}
  };

  const validate = () => {
    const newErrors = {};
    const urlPattern = /^https?:\/\/.+$/i;

    if (formData.facebook && !urlPattern.test(formData.facebook)) {
      newErrors.facebook = "Enter a valid Facebook URL";
    }

    if (formData.instagram && !urlPattern.test(formData.instagram)) {
      newErrors.instagram = "Enter a valid Instagram URL";
    }

    if (formData.xurl && !urlPattern.test(formData.xurl)) {
      newErrors.xurl = "Enter a valid Twitter URL";
    }

    if (formData.linkedin && !urlPattern.test(formData.linkedin)) {
      newErrors.linkedin = "Enter a valid LinkedIn URL";
    }

    if (formData.youtube && !urlPattern.test(formData.youtube)) {
      newErrors.youtube = "Enter a valid YouTube URL";
    }

    if (formData.whatsapp && !urlPattern.test(formData.whatsapp)) {
      newErrors.whatsapp = "Enter a valid Whatsapp URL";
    }

    if (
      !formData.facebook &&
      !formData.instagram &&
      !formData.xurl &&
      !formData.linkedin &&
      !formData.whatsapp &&
      !formData.youtube
    ) {
      newErrors.general = "Nothing to save";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    showLoader();
    setIsLoading(true);

    if (!validate()) {
      setIsLoading(false);
      hideLoader();
      return;
    }

    try {
      const res = await StoreAPI.updateSocialMediaDetails(formData);

      if (res.code === 200) {
        showSuccess(res.message);
      } else {
        showError(res.message);
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  return (
    <>
      <div className="card-header d-flex align-items-center justify-content-between">
        <h4>Social Media Settings</h4>
      </div>
      <div className="card-body">
        <form method="post" onSubmit={handleSubmit}>
          {errors.general && (
            <div className="col-12 mb-3">
              <div className="alert alert-danger py-2">{errors.general}</div>
            </div>
          )}

          <div className="row">
            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label">Facebook</label>
                <input
                  type="text"
                  className="form-control"
                  name="facebook"
                  placeholder="Facebook Url"
                  value={formData.facebook}
                  onChange={handleChange}
                />
                {errors.facebook && (
                  <span className="errors text-danger">{errors.facebook}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label">Instagram</label>
                <input
                  type="text"
                  className="form-control"
                  name="instagram"
                  placeholder="Instagram Url"
                  value={formData.instagram}
                  onChange={handleChange}
                />
                {errors.instagram && (
                  <span className="errors text-danger">{errors.instagram}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label">Linkedin</label>
                <input
                  type="text"
                  className="form-control"
                  name="linkedin"
                  placeholder="Linkedin Url"
                  value={formData.linkedin}
                  onChange={handleChange}
                />
                {errors.linkedin && (
                  <span className="errors text-danger">{errors.linkedin}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label">X</label>
                <input
                  type="text"
                  className="form-control"
                  name="xurl"
                  placeholder="X Url"
                  value={formData.xurl}
                  onChange={handleChange}
                />
                {errors.xurl && (
                  <span className="errors text-danger">{errors.xurl}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label">Youtube</label>
                <input
                  type="text"
                  className="form-control"
                  name="youtube"
                  placeholder="Youtube Url"
                  value={formData.youtube}
                  onChange={handleChange}
                />
                {errors.youtube && (
                  <span className="errors text-danger">{errors.youtube}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label">Whatsapp Link</label>
                <input
                  type="text"
                  className="form-control"
                  name="whatsapp"
                  placeholder="Whatsapp"
                  value={formData.whatsapp}
                  onChange={handleChange}
                />
                {errors.whatsapp && (
                  <span className="errors text-danger">{errors.whatsapp}</span>
                )}
              </div>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-md-12 shipment">
              <h6>Other Settings</h6>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Meta Pixel</label>
                <input
                  type="text"
                  className="form-control"
                  name="metaPixelId"
                  placeholder="123456789012345"
                  value={formData.metaPixelId}
                  onChange={handleChange}
                />
                {errors.metaPixelId && (
                  <span className="errors text-danger">
                    {errors.metaPixelId}
                  </span>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Google Tag Manager Id</label>
                <input
                  type="text"
                  className="form-control"
                  name="googleTagManagerId"
                  placeholder="GTM-XXXXXXX"
                  value={formData.googleTagManagerId}
                  onChange={handleChange}
                />
                {errors.googleTagManagerId && (
                  <span className="errors text-danger">
                    {errors.googleTagManagerId}
                  </span>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Google Analytics</label>
                <input
                  type="text"
                  className="form-control"
                  name="googleAnalyticsId"
                  placeholder="G-XXXXXXX"
                  value={formData.googleAnalyticsId}
                  onChange={handleChange}
                />
                {errors.googleAnalyticsId && (
                  <span className="errors text-danger">
                    {errors.googleAnalyticsId}
                  </span>
                )}
              </div>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-md-12 shipment">
              <h6>Login using social media</h6>

              <div className="alert alert-light border">
                <h6 className="fw-semibold mb-2">Setup Instructions</h6>

                <ol className="ps-3">
                  <li>
                    Open the{" "}
                    <a
                      href="https://console.cloud.google.com"
                      target="_blank"
                      className="text-primary"
                      rel="noopener noreferrer"
                    >
                      Google Cloud Console
                    </a>
                  </li>
                  <li>Create a new project or select an existing project.</li>
                  <li>
                    Go to{" "}
                    <strong>APIs & Services → OAuth Consent Screen</strong> and
                    configure your application details.
                  </li>
                  <li>
                    Navigate to <strong>APIs & Services → Credentials </strong>
                  </li>
                  <li>
                    Click <strong>Create Credentials → OAuth Client ID</strong>.
                  </li>
                  <li>
                    Select <strong>Web Application</strong> as the application
                    type.
                  </li>
                  <li>
                    Add your website URL in{" "}
                    <strong>Authorized JavaScript Origins</strong>.
                  </li>
                  <li>
                    Add your callback URL in{" "}
                    <strong>Authorized Redirect URIs</strong>.
                  </li>
                  <li>
                    Copy the generated <strong>Client ID</strong> and paste it
                    below.
                  </li>
                  <li>
                    Save the settings and click <strong>Submit</strong>.
                  </li>
                </ol>
                <div className="mt-2">
                  <strong>Example Redirect URI:</strong>
                  <br />
                  <code>https://yourdomain.com/auth/google/callback</code>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Client Id</label>
                <input
                  type="text"
                  className="form-control"
                  name="googleClientId"
                  placeholder="Google Client Id"
                  value={formData.googleClientId}
                  onChange={handleChange}
                />
                {errors.googleClientId && (
                  <span className="errors text-danger">
                    {errors.googleClientId}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 d-flex justify-content-end">
              {!isLoading && (
                <button
                  type="submit"
                  id="submitBtn"
                  className="btn btn-primary shadow-none"
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default SocialMediaSettings;
